<template>
    <div slot="content" class="tile">
        <div class="tile-content">
            <div class="grid-content">
                <div class="grid-item">
                    <div class="avatar avatar-l avatar-description align-items-start">
                        <v-avatar :initials="initials"/>
                        <div class="avatar-info">
                            <h2 v-fs-block>{{fullName}}</h2>
                            <p class="avatar-info-muted-text">{{memberSince}}</p>
                            <p class="avatar-info-muted-text" v-fs-block>{{profile.email}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="tile-content">
            <reset-password-modal @input="input"/>
        </div>
    </div>
</template>

<script>
    import {vFormTile, vErrorMessages} from '@/components/form';
    import vAvatar from '@/components/v-avatar';
    import ResetPasswordModal from './reset-password-modal';

    export default {
        name: 'profile-summary',
        components: {
            vFormTile,
            vErrorMessages,
            vAvatar,
            ResetPasswordModal,
        },
        props: {
            profile: {
                required: true,
            },
        },
        computed: {
            fullName() {
                return `${this.$store.getters['user/fullName']}`;
            },
            initials() {
                return `${this.$store.getters['user/initials']}`;
            },
            memberSince() {
                return `${this.$store.getters['user/memberSince']}`;
            },
        },
        methods: {
            input(profileAttributes) {
                this.$emit('input', profileAttributes);
            },
        },
    };
</script>
